// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// import Synoset from "./../../modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TreeNodeViewModel from "./../../factories/tree-node";
import "./../../bindings/bao-tree";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
function TicketStructureDialog(tabPage, parent, type) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _msgAllSubFolders : KnockoutObservable<string> = ko.observable("");
    switch (type) {
        case "TicketCategory":
            _msgAllSubFolders = Bao.Session.GetMessage("TicketCategoryStructureAll");
            break;
        case "TicketService":
            _msgAllSubFolders = Bao.Session.GetMessage("TicketServiceStructureAll");
            break;
        default:
            break;
    }
    self.Type = type;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("500px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                var shouldReturn = false;
                switch (self.Type) {
                    case "TicketCategory":
                        $.each(parent.TicketCategoryStructureRoleCollection(), function (index, item) {
                            if (item.TicketCategoryIdLevel1 == self.Dialog.ViewModel().TicketCategoryIdLevel1() && item.TicketCategoryIdLevel2 == self.Dialog.ViewModel().TicketCategoryIdLevel2() && item.TicketCategoryIdLevel3 == self.Dialog.ViewModel().TicketCategoryIdLevel3() && item.TicketCategoryIdLevel4 == self.Dialog.ViewModel().TicketCategoryIdLevel4() && item.TicketCategoryIdLevel5 == self.Dialog.ViewModel().TicketCategoryIdLevel5() && (self.Dialog.ViewModel().IsTicketCategoryStructureRoleNew() || item.TicketCategoryStructureRoleId != self.Dialog.ViewModel().TicketCategoryStructureRoleId())) {
                                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgTicketCategoryStructureRoleExists"), "info");
                                shouldReturn = true;
                            }
                        });
                        break;
                    case "TicketService":
                        $.each(parent.TicketServiceStructureRoleCollection(), function (index, item) {
                            if (item.TicketServiceIdLevel1 == self.Dialog.ViewModel().TicketServiceIdLevel1() && item.TicketServiceIdLevel2 == self.Dialog.ViewModel().TicketServiceIdLevel2() && item.TicketServiceIdLevel3 == self.Dialog.ViewModel().TicketServiceIdLevel3() && item.TicketServiceIdLevel4 == self.Dialog.ViewModel().TicketServiceIdLevel4() && item.TicketServiceIdLevel5 == self.Dialog.ViewModel().TicketServiceIdLevel5() && (self.Dialog.ViewModel().IsTicketServiceStructureRoleNew() || item.TicketServiceStructureRoleId != self.Dialog.ViewModel().TicketServiceStructureRoleId())) {
                                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgTicketServiceStructureRoleExists"), "info");
                                shouldReturn = true;
                            }
                        });
                        break;
                    default:
                        break;
                }
                if (shouldReturn) {
                    return;
                }
                if (!Bao.Utils.String.IsNullOrEmpty(self.Dialog.ViewModel().CompleteFolderName())) {
                    self.Dialog.IsLoading(true);
                    switch (self.Type) {
                        case "TicketCategory":
                            parent.AddTicketCategoryStructureRole(self.Dialog.ViewModel(), parent.Role.RoleId());
                            break;
                        case "TicketService":
                            parent.AddTicketServiceStructureRole(self.Dialog.ViewModel(), parent.Role.RoleId());
                            break;
                        default:
                            break;
                    }
                    self.Dialog.IsLoading(false);
                    self.Dialog.Close();
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowTicketStructureRoleDialog = function (roleId, ticketStructureRoleId, isNew) {
        return Bao.post("UadmCustom/RoleTab/ShowTicketStructureRoleDialog", JSON.stringify({
            sessionTabId: parent.Role.TabPage.SessionTabId,
            roleId: roleId,
            itemId: ticketStructureRoleId,
            isNew: isNew,
            type: self.Type
        }), function (value) {
            tabPage.IsLoading(true);
            var dialogModel = ko.map.fromJS(value.Model);
            dialogModel.OpenTreeDialog = function (type) {
                tabPage.IsLoading(true);
                Bao.post("UadmCustom/RoleTab/GetTreeDialogDataSource", JSON.stringify({
                    type: type
                }), function (value) {
                    var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                    var dialogViewModel : any = {};
                    dialogViewModel.NodeToggled = function () {
                        dialog.SetPosition();
                    };
                    var dataSource = [];
                    for (var i = 0; i < value.nodes.length; i++) {
                        dataSource.push(new TreeNodeViewModel(value.nodes[i]));
                    }
                    dialogViewModel.Nodes = ko.observableArray(dataSource);
                    dialogViewModel.SelectedCategory = ko.observable();
                    dialogViewModel.SelectedCategory.subscribe(function () {
                        dialogViewModel.okClick();
                    });
                    dialogViewModel.SelectedService = ko.observable();
                    dialogViewModel.SelectedService.subscribe(function () {
                        dialogViewModel.okClick();
                    });
                    dialogViewModel.okClick = function () {
                        tabPage.IsLoading(true);
                        dialogModel.SelectedTicketStructureId = ko.observable();
                        var selectedNode;
                        switch (self.Type) {
                            case "TicketCategory":
                                selectedNode = dialogViewModel.SelectedCategory();
                                if (selectedNode != null) {
                                    if (selectedNode.IsAllowed()) {
                                        return Bao.post("UadmCustom/RoleTab/GetTicketCategoryStructure", JSON.stringify({
                                            selectedTicketCategoryId: selectedNode.Id()
                                        }), function (result) {
                                            dialogModel.CompleteFolderName(result.CompleteTicketCategoryStructure);
                                            dialogModel.SelectedTicketStructureId(result.TicketStructureId);
                                            dialogModel.TicketCategoryIdLevel1(result.TicketCategoryIdLevel1);
                                            dialogModel.TicketCategoryIdLevel2(result.TicketCategoryIdLevel2);
                                            dialogModel.TicketCategoryIdLevel3(result.TicketCategoryIdLevel3);
                                            dialogModel.TicketCategoryIdLevel4(result.TicketCategoryIdLevel4);
                                            dialogModel.TicketCategoryIdLevel5(result.TicketCategoryIdLevel5);
                                            tabPage.IsLoading(false);
                                            dialog.Close();
                                        });
                                    }
                                }
                                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketCategoryInvalidSelection"), "info");
                                break;
                            case "TicketService":
                                selectedNode = dialogViewModel.SelectedService();
                                if (selectedNode != null) {
                                    if (selectedNode.IsAllowed()) {
                                        return Bao.post("UadmCustom/RoleTab/GetTicketServiceStructure", JSON.stringify({
                                            selectedTicketServiceId: selectedNode.Id()
                                        }), function (result) {
                                            dialogModel.CompleteFolderName(result.CompleteTicketServiceStructure);
                                            dialogModel.SelectedTicketStructureId(result.TicketStructureId);
                                            dialogModel.TicketServiceIdLevel1(result.TicketServiceIdLevel1);
                                            dialogModel.TicketServiceIdLevel2(result.TicketServiceIdLevel2);
                                            dialogModel.TicketServiceIdLevel3(result.TicketServiceIdLevel3);
                                            dialogModel.TicketServiceIdLevel4(result.TicketServiceIdLevel4);
                                            dialogModel.TicketServiceIdLevel5(result.TicketServiceIdLevel5);
                                            tabPage.IsLoading(false);
                                            dialog.Close();
                                        });
                                    }
                                }
                                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                                break;
                        }
                        tabPage.IsLoading(false);
                        return null;
                    };
                    dialog.Width(500);
                    dialog.ViewModel(dialogViewModel);
                    dialog.Template(value.Message);
                    dialog.Buttons([{
                            Title: Bao.Session.GetMessage("msgOk"),
                            Enabled: ko.observable(true),
                            Click: dialogViewModel.okClick
                        }]);
                    dialog.Open();
                    tabPage.IsLoading(false);
                    dialog.SetPosition();
                });
            };
            dialogModel.DeleteTicketCategory = function () {
                dialogModel.CompleteFolderName(_msgAllSubFolders());
                dialogModel.SelectedTicketStructureId(null);
                dialogModel.TicketCategoryIdLevel1(null);
                dialogModel.TicketCategoryIdLevel2(null);
                dialogModel.TicketCategoryIdLevel3(null);
                dialogModel.TicketCategoryIdLevel4(null);
                dialogModel.TicketCategoryIdLevel5(null);
            };
            dialogModel.DeleteTicketService = function () {
                dialogModel.CompleteFolderName(_msgAllSubFolders());
                dialogModel.SelectedTicketStructureId(null);
                dialogModel.TicketServiceIdLevel1(null);
                dialogModel.TicketServiceIdLevel2(null);
                dialogModel.TicketServiceIdLevel3(null);
                dialogModel.TicketServiceIdLevel4(null);
                dialogModel.TicketServiceIdLevel5(null);
            };
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
}
export default TicketStructureDialog;